import React from "react";
import { useParams } from "react-router";
import LeftSide from "./LeftSide";
import RightSide from "./RightSide";
import "./style.scss";
import { useUnitGroups } from "../../../../api/unitGroups";
import LeftSideSkeleton from "./LeftSide/LeftSideSkeleton";
import RightSideSkeleton from "./RightSide/RightSideSkeleton";
import { Alert } from "antd";

const UnitDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const {
    data: unitApiData,
    isLoading,
    error,
    refetch = () => {},
  } = useUnitGroups(
    {
      reference_no: id,
    },
    true,
    1,
    1
  );
  const unit = unitApiData?.data.unitGroups[0];

  if (error)
    return <Alert type="error" message="Failed to load unit details" />;

  return (
    <div className="ticket-details-frame flex">
      {isLoading || !unit ? (
        <div className="flex mt-20 w-full">
          <LeftSideSkeleton />
          <RightSideSkeleton />
        </div>
      ) : (
        <>
          <LeftSide
            unitType="Primary"
            unit={unit as any}
            refetchUnit={refetch}
          />
          <RightSide unitType="Primary" unit={unit} refetchUnit={refetch} />
        </>
      )}
    </div>
  );
};

export default UnitDetails;
